/* eslint-disable */
import { notificationServices } from '@/Services';
import moment from 'moment';
import { useQualityAnalysisStore } from '../QualityAnalysisStore';
import { DatePicker, DateRangePicker } from 'rsuite';
export const getAnalysisType = (activeAnalysisTab, state) => {
	let obj = {};
	if (state?.activeTab == 'sourcing') {
		if (activeAnalysisTab === 'quality') {
			obj = {
				tabType: 'qualityAnalysis',
			};
		}
		if (activeAnalysisTab === 'failure') {
			obj = {
				tabType: 'failureAnalysis',
				failureAnalysis: {
					qualityParameterId:
						state?.selectedQualityAnalysisParameter === 'all'
							? null
							: state?.selectedQualityAnalysisParameter,
				},
			};
		}
		if (activeAnalysisTab === 'statistical') {
			if (!state?.selectedQualityParameterProduct) {
				notificationServices.generateNotification({
					type: 'error',
					message: 'Please select a quality parameter !!',
				});
				return;
			}
			obj = {
				tabType: 'statisticalAnalysis',
				statisticalFilter: {
					productIds: [state?.selectedQualityParameterProduct],
					qualityParameterId: state?.selectedQualityAnalysisParameter,
				},
			};
		}
	} else if (state?.activeTab == 'production') {
		if (activeAnalysisTab === 'quality') {
			obj = {
				tabType: 'qualityAnalysis',
			};
		}
		if (activeAnalysisTab === 'failure') {
			const machineFailureAnalysis = getMachineFailureAnalysis(state);
			obj = {
				tabType: 'failureAnalysis',
				...(machineFailureAnalysis && {
					failureAnalysis: machineFailureAnalysis,
				}),
			};
		}
		if (activeAnalysisTab === 'statistical') {
			const productIds = [];
			const variantIds = [];
			if (!state?.selectedQualityParameterProduct) {
				!state?.suppressNotification && notificationServices.generateNotification({
					type: 'warning',
					message: 'Please select a product !!',
				});
				return;
			}
			let parameterId = null;
			if (state?.selectedQualityAnalysisParameter == 'temperature') {
				parameterId = 1;
			}
			if (state?.selectedQualityAnalysisParameter == 'weight') {
				const productsVariants =
					state?.selectedQualityParameterProduct.split('-');
				productIds.push(Number(productsVariants[0]));
				variantIds.push(Number(productsVariants[1]));
				parameterId = 2;
			} else {
				productIds.push(Number(state?.selectedQualityParameterProduct));
			}
			const productList = state?.globalProductList.filter((product) =>
				productIds.includes(Number(product.id))
			);
			obj = {
				tabType: 'statisticalAnalysis',
				statisticalFilter: {
					productIds: productIds,
					variantIds: variantIds,
					qualityParameterId:
						parameterId || state?.selectedQualityAnalysisParameter,
				},
				brandFilter: productList.map((product) => product.brandId),
			};
		}
	}

	return obj;
};

const getMachineFailureAnalysis = (state) => {
	if (state?.selectedQualityAnalysisParameter === 'weight') {
		return {
			weight: {
				key: 'weight',
				over: true,
				under: true,
			},
		};
	} else if (state?.selectedQualityAnalysisParameter === 'temperature') {
		return {
			temp: {
				key: 'temp',
				over: true,
				under: true,
			},
		};
	}
};
export const getGroupingType = (activeGroupingType, state) => {
	let obj = {};
	if (state?.activeAnalysisTab === 'statistical') {
		return {};
	}
	if (activeGroupingType === 'product') {
		const { productWiseDropdown } = state;
		const activeProduct = productWiseDropdown.find((item) => item.active);
		obj = {
			dateRangeFilter: {
				from:
					moment(state.dateRangeObj?.from).format('YYYY-MM-DD') ||
					null,
				to: moment(state.dateRangeObj?.to).format('YYYY-MM-DD') || null,
			},
			grouping: {
				active: true,
				type: 'productGroupWise',
				currentSelection: activeProduct.key,
				selection: {
					category: state?.chartSelectionObj?.category ?? null,
					subCategory: state?.chartSelectionObj?.subCategory ?? null,
				},
			},
		};
	}
	if (activeGroupingType === 'geography') {
		const { geographyWiseDropdown } = state;
		const activeGeography = geographyWiseDropdown.find(
			(item) => item.active
		);
		obj = {
			dateRangeFilter: {
				from:
					moment(state.dateRangeObj?.from).format('YYYY-MM-DD') ||
					null,
				to: moment(state.dateRangeObj?.to).format('YYYY-MM-DD') || null,
			},
			grouping: {
				active: true,
				type: 'geographyWise',
				currentSelection: activeGeography.key,
				selection: {
					region: state?.chartSelectionObj?.region ?? null,
					city: state?.chartSelectionObj?.city ?? null,
				},
			},
		};
	}
	if (activeGroupingType === 'time') {
		const { timeRangesDropdown } = state;
		const { year, month, day, quarter, week, period } =
			state.dateInfo || {};
		const activeTimeRange = timeRangesDropdown.find((item) => item.active);
		obj = {
			grouping: {
				active: true,
				type: 'periodWise',
				currentSelection: activeTimeRange.key,
				selection: {
					year: year ?? null,
					month: month ?? null,
					day: day ?? null,
					quarter: quarter ?? null,
				},
			},
		};
	}
	return obj;
};

export const metricsToCardData = (metrics, setCardData) => {
	if (!metrics) return;

	// Get current cardData first
	const state = useQualityAnalysisStore.getState();
	const currentCardData = state.cardData;

	// Create a new array with updated values
	const updatedCardData = currentCardData.map((card) => {
		const key = card.id.toString();
		const value = metrics[key];

		if (value) {
			return {
				...card,
				cp: value?.cp
					? isNaN(Number(value.cp))
						? '-'
						: Number(value.cp).toFixed(2)
					: '-',
				cpk: value?.cpk
					? isNaN(Number(value.cpk))
						? '-'
						: Number(value.cpk).toFixed(2)
					: '-',
				total: value?.total || 0,
				pass: value?.passed || 0,
				lsl: value?.lowerLimit || 0,
				mean: Number(value?.mean).toFixed(2) || 0,
				usl: value?.upperLimit || 0,
				standardDeviation: Number(value?.stddev).toFixed(2) || 0,
				passPercent: value?.passpercent || 0,
				failPercent: value?.failpercent || 0,
				underWeight: value?.underWeight || 0,
				overWeight: value?.overWeight || 0,
			};
		}
		return card;
	});

	// Update state once with the new array
	setCardData(updatedCardData);
};


const getDailyCardData = (newId, productName, borderColor) => {
	return {
		id: newId,
		name: productName,
		cp: '',
		cpk: '',
		timeFrame: {
			timeType: 'daily',
			value: new Date(),
			component: (
				<DatePicker
					placement="rightEnd"
					oneTap
					cleanable={false}
					showOneCalendar
					format='yyyy-MM-dd'
					value={new Date()}
					defaultOpen={true}
				/>
			),
		},
		borderColor: borderColor,
		total: 0,
		pass: 0,
		lsl: 0,
		mean: 0,
		usl: 0,
		standardDeviation: 0,
		passPercent: 0,
		failPercent: 0,
		underWeight: 0,
		overWeight: 0,
	}
};

export const getWeeklyCardData = (newId, productName, borderColor, startDate = null, endDate = null) => {
	return {
		id: newId,
		name: productName,
		cp: '',
		cpk: '',
		timeFrame: {
			timeType: 'weekly',
			value: [
				startDate ?? new Date(new Date().setDate(new Date().getDate() - new Date().getDay())),
				endDate ?? new Date(new Date().setDate(new Date().getDate() - new Date().getDay() + 6)),
			],
			component: (
				<DateRangePicker
					format='yyyy-MM-dd'
					hoverRange='week'
					oneTap
					showOneCalendar
					cleanable={false}
					placement="rightEnd"
					placeholder='yyyy-MM-dd ~ yyyy-MM-dd'
					style={{ width: '100%' }}
					value={[
						new Date(
							new Date().setDate(
								new Date().getDate() -
								new Date().getDay()
							)
						),
						new Date(
							new Date().setDate(
								new Date().getDate() -
								new Date().getDay() +
								6
							)
						),
					]}
					defaultOpen={true}
				/>
			),
		},
		borderColor: borderColor,
		total: 0,
		pass: 0,
		lsl: 0,
		mean: 0,
		usl: 0,
		standardDeviation: 0,
		passPercent: 0,
		failPercent: 0,
		underWeight: 0,
		overWeight: 0,
	}

}

const getMonthlyCardData = (newId, productName, borderColor) => {
	return {
		id: newId,
		name: productName,
		cp: '',
		cpk: '',
		timeFrame: {
			timeType: 'monthly',
			value: [
				new Date(new Date().setDate(1)),
				new Date(
					new Date().setMonth(new Date().getMonth() + 1, 0)
				),
			],
			component: (
				<DateRangePicker
					hoverRange='month'
					oneTap
					cleanable={false}
					showOneCalendar
					placement="rightEnd"
					value={[
						new Date(new Date().setDate(1)),
						new Date(
							new Date().setMonth(
								new Date().getMonth() + 1,
								0
							)
						),
					]}
					defaultOpen={true}
				/>
			),
		},
		borderColor: borderColor,
		total: 0,
		pass: 0,
		lsl: 0,
		mean: 0,
		usl: 0,
		standardDeviation: 0,
		passPercent: 0,
		failPercent: 0,
		underWeight: 0,
		overWeight: 0,
	}
}

export const handleAddTimeFrame = (productList = [], parentHandleCall = null, timeFrame = null, variantId = null, startDate = null, endDate = null, userSelected = false) => {
	const state = useQualityAnalysisStore.getState();

	if (!state?.selectedQualityParameterProduct) {
		notificationServices.generateNotification({
			type: 'info',
			message: 'Please select at least one product',
		});
		return;
	}
	const newId =
		state?.cardData?.length > 0
			? Math.max(...state?.cardData.map((item) => item.id)) + 1
			: 1;

	const borderColors = [
		'#FF6384',
		'#36A2EB',
		'#FFCE56',
		'#4BC0C0',
		'#9966FF',
		'#FF9F40',
		'#8AC926',
		'#1982C4',
	];
	// hex of ring-green-400 #10B981
	const newCardData = [];
	const productName =
		productList.find(
			(p) =>
				p.id === (variantId ?? state?.selectedQualityParameterProduct) ||
				Number(p.id) === Number(variantId ?? state?.selectedQualityParameterProduct)
		)?.title || 'Unknown Product';
	const borderColorIndex = state?.cardData?.length % borderColors.length;
	let borderColor = borderColors[borderColorIndex];
	if (userSelected) {
		borderColor = '#10B981';
	}
	console.log(`productName: ${productName}, borderColor: ${borderColor}, timeFrame: ${timeFrame}, variantId: ${variantId}, startDate: ${startDate}, endDate: ${endDate}, userSelected: ${userSelected}`);
	switch (timeFrame ?? state?.timeFrame) {
		case 'Daily': {
			newCardData.push({ ...getDailyCardData(newId, productName, borderColor), userSelected });
			break;
		}
		case 'Week': {
			newCardData.push({ ...getWeeklyCardData(newId, productName, borderColor, startDate, endDate), userSelected });
			break;
		}
		case 'Month': {
			newCardData.push({ ...getMonthlyCardData(newId, productName, borderColor), userSelected });
			break;
		}
		case 'Year': {
			newCardData.push({
				id: newId,
				name: productName,
				cp: '',
				cpk: '',
				timeFrame: {
					timeType: 'yearly',
					value: new Date(),
					component: (
						<DatePicker
							cleanable={false}
							placement="rightEnd"
							hoverRange='year'
							value={new Date()}
							defaultOpen={true}
						/>
					),
				},
				borderColor: borderColor,
				total: 0,
				pass: 0,
				lsl: 0,
				mean: 0,
				usl: 0,
				standardDeviation: 0,
				passPercent: 0,
				failPercent: 0,
				underWeight: 0,
				overWeight: 0,
				userSelected,
			});
			break;
		}
		case 'Custom': {
			newCardData.push({
				id: newId,
				name: productName,
				cp: '',
				cpk: '',
				timeFrame: {
					timeType: 'custom',
					value: [
						startDate ?? new Date(),
						endDate ?? new Date(),
					],
					component: (
						<DateRangePicker
							cleanable={false}
							placement="rightEnd"
							value={[startDate ?? new Date(), endDate ?? new Date()]}
							defaultOpen={true}
						/>
					),
				},
				borderColor: borderColor,
				total: 0,
				pass: 0,
				lsl: 0,
				mean: 0,
				usl: 0,
				standardDeviation: 0,
				passPercent: 0,
				failPercent: 0,
				underWeight: 0,
				overWeight: 0,
				userSelected,
			});
			break;
		}
	}
	state?.setCardData([...state?.cardData, ...newCardData], parentHandleCall ?? true);
};

export const cardLegendLabelGenerator = (card) => {
	let label = '';
	const value = card?.timeFrame?.value;
	if (value) {
		if (Array.isArray(value)) {
			const startDate = moment(value[0]);
			const endDate = moment(value[1]);

			if (startDate.isSame(endDate, 'day')) {
				// Same day
				label = startDate.format('MMM D YYYY');
			} else if (startDate.isSame(endDate, 'year')) {
				if (startDate.isSame(endDate, 'month')) {
					// Same month and year
					label = `${startDate.format('MMM')} ${startDate.format('D')} - ${endDate.format('D')}, ${startDate.format('YYYY')}`;
				} else {
					// Same year, different months
					label = `${startDate.format('MMM D')} - ${endDate.format('MMM D')}, ${startDate.format('YYYY')}`;
				}
			} else {
				// Different years
				label = `${startDate.format('MMM D YYYY')} - ${endDate.format('MMM D YYYY')}`;
			}
		} else {
			label = moment(value).format('MMM D YYYY');
		}
	}
	return label;
};
export const parseDefaultStatisticalAnalysisData = (variantGroupWeekData) => {
	const finalResult = {};

	for (const [variantId, weekData] of Object.entries(variantGroupWeekData)) {
		// Count weeks
		const weekNumbers = Object.keys(weekData).map(w => Number(w));

		// Filter condition: only variants having more than 3 weeks
		if (weekNumbers.length <= 5) continue;

		// Sort week numbers from latest to oldest (descending)
		const sortedWeekNumbers = weekNumbers.sort((a, b) => b - a);

		// Build week → dateRange list
		const weekRanges = sortedWeekNumbers.map(week => {
			const start = moment().isoWeek(week).startOf("isoWeek").format("YYYY-MM-DD");
			const end = moment().isoWeek(week).endOf("isoWeek").format("YYYY-MM-DD");

			return {
				week,
				from: start,
				to: end
			};
		});

		// Assign to final object
		finalResult[variantId.replace(".0", "")] = weekRanges;
	}
	return finalResult;
};

